import { useEffect, useState } from 'react';
import createCache from '@emotion/cache';
import { getCssAssetUrl } from './webComponentUtils';
const useWebComponentCache = (componentTag, partition) => {
    const [cache, setCache] = useState(null);
    const [stylesLoading, setStylesLoading] = useState(true);
    const { shadowRoot } = document.getElementsByTagName(componentTag)[0];
    const cssAssetUrl = getCssAssetUrl(partition);
    useEffect(() => {
        if (shadowRoot) {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = cssAssetUrl;
            shadowRoot.appendChild(link);
            // Listen for load event to know when styles are applied from the css file
            // Elements from @cmd/ui-components depend on these styles to render correctly
            link.addEventListener('load', () => {
                setStylesLoading(false);
            });
        }
        setCache(createCache({
            key: `${componentTag}-emotion-cache`,
            prepend: true,
            container: shadowRoot || document.head,
        }));
    }, []);
    return {
        cache,
        stylesLoading,
    };
};
export default useWebComponentCache;
